import { createFileRoute } from "@tanstack/react-router";
import { Lagerauswertung } from "@/components/lagerauswertung/lagerauswertung";

export const Route = createFileRoute("/lagerauswertung/wicker")({
  component: Lagerauswertung,
});
